export default function OpenCashRegister() {
  return (
    <section className="sales-layout__page">
      <h1>Kasse eröffnen</h1>
      <p>Die Kassen-Eröffnung ist in Vorbereitung.</p>
    </section>
  );
}
